import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation } from '@tanstack/vue-query'
import { useRoute } from 'vue-router'

export type ObjectMapPrintItem = {
  id: number
  object_type_id: number
}

export const usePrintObjectMaps = () => {
  const http = useHttp()
  const { addError } = useNotification()
  const { trs } = useTranslate()
  const route = useRoute()

  const mutation = useMutation({
    mutationFn: (objects: ObjectMapPrintItem[]) =>
      http.post(
        `/inventory/objects/${route.params.object_id}/map-print`,
        { objects },
        { responseType: 'arraybuffer' },
      ),
  })

  const print = async (objects: ObjectMapPrintItem[]) => {
    try {
      return await mutation.mutateAsync(objects)
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    print,
  }
}
